<div (click)="handleClick()" class="simple-card-status">
  <p>{{ title }}</p>
  <h4>
    {{ quantity }}
  </h4>
</div>
